<template>
  <div id="stockDetails" class="q-pa-md">
    <el-row>
      <PageHeader content="库存明细" />
      <el-button id="addBtn" type="primary" @click="addDetails">添加记录</el-button>
    </el-row>
    <el-form ref="form" :model="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <CustSelector ref="custSelector" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="库存名称">
            <el-input v-model="form.stockName" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <YarnSelector ref="yarnSelector" :yarnId="form.yarnType" :disabled="disabled" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="库存类型">
            <el-select
              v-model="form.stockType"
              placeholder="请选择类型"
              style="width: 100%;"
              :disabled="disabled"
            >
              <el-option label="胚纱" value="0"></el-option>
              <el-option label="色纱" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" v-if="form.stockType == 0">
          <el-form-item label="缠绕类型">
            <el-select
              v-model="form.windType"
              placeholder="请选择类型"
              style="width: 100%;"
              :disabled="disabled"
            >
              <el-option label="筒纱" value="0"></el-option>
              <el-option label="绞纱" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="库存数量(KG)">
            <el-input type="number" v-model="form.stockQuantity" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="位置">
            <el-input v-model="form.location" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="库存明细">
        <el-table
          :data="stockDetails.slice((queryForm.pageNum-1)*queryForm.pageSize,queryForm.pageNum*queryForm.pageSize)"
          style="width: 100%"
          border
        >
          <el-table-column prop="happenDate" label="发生日期" sortable></el-table-column>
          <el-table-column prop="direction" label="进出方向">
            <template slot-scope="scope">
              {{scope.row.direction=="0"?"入库":"出库"}}
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="数量(KG)"></el-table-column>
          <el-table-column prop="unitPrice" label="单价(元)"></el-table-column>
          <el-table-column prop="batchNo" label="批号"></el-table-column>
          <el-table-column prop="sourceNo" label="来源批号"></el-table-column>
          <el-table-column prop="balance" label="库存(KG)"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <!-- <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="detail(scope.$index, scope.row)">明细</el-button>
              <el-button size="mini" type="danger" @click="removeOrder(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>-->
        </el-table>
        <el-pagination
          :current-page.sync="queryForm.pageNum"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10,20,30,40,50]"
          :total="stockDetails.length"
          layout="total,sizes, prev, pager, next"
        ></el-pagination>
      </el-form-item>
    </el-form>

    <el-dialog v-dialogDrag title="添加出入库记录" :visible.sync="formVisible" :width="dialogWidth">
      <el-form ref="saveForm" :model="saveForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="进出方向">
              <el-select v-model="saveForm.direction" placeholder="请选择方向" style="width: 100%;">
                <el-option label="进" value="0"></el-option>
                <el-option label="出" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发生日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="saveForm.happenDate"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="数量(KG)">
              <el-input type="number" v-model="saveForm.quantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单价(元)">
              <el-input type="number" v-model="saveForm.unitPrice"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="批号">
              <el-input v-model="saveForm.batchNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来源批号">
              <el-input v-model="saveForm.sourceNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="saveForm.remark"
            :autosize="{ minRows: 4, maxRows: 10}"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveDetails">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from "../components/PageHeader.vue";
import CustSelector from "../components/CustSelector.vue";
import YarnSelector from "@/components/YarnSelector.vue";
export default {
  components: {
    PageHeader,
    CustSelector,
    YarnSelector,
  },
  data() {
    return {
      form: {},
      stockDetails: [],
      queryForm: { pageNum: 1, pageSize: 10 },
      formVisible: false,
      dialogWidth: "600px",
      saveForm: {},
      id: "",
      disabled: false,
    };
  },
  methods: {
    query(id) {
      var url = "erp/stock/" + id;
      var self = this;
      this.$axios.get(url).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.form = response.data.data;
          //客户编号
          self.$refs.custSelector.customerNo = self.form.customerNo;
          self.$refs.yarnSelector.selectYarnId = self.form.yarnType;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    queryDetails(id) {
      var url = "erp/stock/" + id + "/details";
      var self = this;
      this.$axios.get(url).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.stockDetails = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    addDetails() {
      this.formVisible = true;
    },
    saveDetails() {
      this.saveForm.stockId = this.form.id;
      var self = this;
      this.$axios
        .post("/erp/stock/details", self.saveForm)
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.$message({
              message: "保存成功",
              type: "success",
            });
            self.query(self.id);
            self.queryDetails(self.id);
            self.formVisible = false;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
  },
  mounted: function () {
    //库存ID
    const id = this.$route.params.id;
    this.id = id;
    this.query(id);
    this.queryDetails(id);
    this.$refs.custSelector.disabled = true;
  },
};
</script>

<style scoped>
#addBtn {
  float: right;
  margin-top: -25px;
  margin-bottom: 50px;
}
</style>